import {css} from 'lit';

/* eslint-disable prettier/prettier */
export default css`:root {
  /* fonts */
  --font-title: "Noto Sans", sans-serif;
  --font-content: "Noto Sans", sans-serif;
  --font-code: "Noto Sans Mono", monospace;
  /* colors */
  --color-body: #fef7ff;
  --color-body-contrast: #222428;
  --color-medium: #7a757f;
  --color-medium-contrast: #f4f5f8;
  --color-primary: #68548e;
  --color-primary-contrast: #f4f5f8;
  --color-secondary: #635b70;
  --color-secondary-contrast: #f4f5f8;
  --color-info: #0a86a8;
  --color-info-contrast: #f4f5f8;
  --color-success: #518241;
  --color-success-contrast: #f4f5f8;
  --color-warning: #d87738;
  --color-warning-contrast: #f4f5f8;
  --color-danger: #ba1a1b;
  --color-danger-contrast: #f4f5f8;
  /* gradients */
  --gradient-direction: 90deg;
  /* sizes */
  --size-base: 16px;
  --size-text: 1;
  --size-space: 1;
  --size-radius: .25;
  --size-border: 1px;
  --size-outline: 1px;
  --size-line: 1.5;
  --size-letter: normal;
  /* shadows */
  --shadow-xs: 0 0 0 1px #1c1b1d0d;
  --shadow-sm: 0 1px 3px 0 #1c1b1d1a, 0 1px 2px 0 #1c1b1d0f;
  --shadow-md: 0 4px 6px -1px #1c1b1d1a, 0 2px 4px -1px #1c1b1d0f;
  --shadow-lg: 0 20px 25px -5px #1c1b1d1a, 0 10px 10px -5px #1c1b1d0a;
  --shadow-xl: 0px 0px 0px 1px #1c1b1d1a, 0px 5px 10px #1c1b1d33, 0px 15px 40px #1c1b1d66;
  --shadow-inset: inset 0 2px 4px 0 #1c1b1d0d;
}`;
/* eslint-enable prettier/prettier */
